import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {UserInfo} from "../types/interfaces";
import {getLoggedInUser} from "../utils/functions";

type ServiceItem = {
    title: string;
    description: string;
    icon: React.ReactNode;
    path: string;
};

export default function HomePage() {
    const navigate = useNavigate();
    const [username, setUsername] = useState<string>('');
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
    const [currentUser, setCurrentUser] = useState<UserInfo|null>(null);

    useEffect(() :void => {
        const getCurrentUser = async () => {
            const loggedInUser: UserInfo | null = await getLoggedInUser()
            if (loggedInUser === null) {
                navigate('/error')
            }
            setCurrentUser(loggedInUser)
        }
        getCurrentUser()

    }, [navigate]);

    const handleNavigation = (path: string) => {
        navigate(path);
    };

    const handleLogout = () => {
        // Simple logout - just clear storage and redirect
        localStorage.removeItem('user');
        navigate('/', { replace: true });
    };

    console.log(currentUser)

    const fieldServices: ServiceItem[] = [
        {
            title: "Search Subscriber",
            description: "Search for Natural Subscribers using MSISDN and Document Number",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 text-green-700 mb-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607z"
                    />
                </svg>
            ),
            path: "/search-dashboard",
        },
        {
            title: "KYC Registration",
            description: "Know Your Customer registration process",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 text-green-700 mb-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                    />
                </svg>
            ),
            path: "/register-subscriber",
        },
        {
            title: "Online Application",
            description: "Submit online service applications",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 text-green-700 mb-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                </svg>
            ),
            path: "/online-application",
        },
        {
            title: "Admin Ops",
            description: "Perform Administrator tasks",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 text-green-700 mb-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                </svg>
            ),
            path: "/admin",
        }
    ];

    const servicesToRender: ServiceItem[] = React.useMemo(() => {
        if (currentUser?.roles && Array.isArray(currentUser.roles) && currentUser.roles.includes('kyc_admin')) {
            return fieldServices;
        }
        return fieldServices.filter(s => s.title !== 'Admin Ops');
    }, [currentUser, fieldServices]);

    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-8">
            {/* Header */}
            {/*<header className="mb-8 relative">*/}
            {/*    /!* User Menu - Top Right Corner *!/*/}
            {/*    <div className="absolute top-2 right-2 z-10">*/}
            {/*        <div className="relative">*/}
            {/*            /!* Menu Button *!/*/}
            {/*            <button*/}
            {/*                onClick={() => setIsMenuOpen(!isMenuOpen)}*/}
            {/*                className="flex items-center space-x-2 bg-green-1000 hover:bg-green-800 text-white px-3 py-2 rounded-lg shadow-md transition-colors text-sm"*/}
            {/*            >*/}
            {/*                <svg*/}
            {/*                    xmlns="http://www.w3.org/2000/svg"*/}
            {/*                    className="h-4 w-4"*/}
            {/*                    fill="none"*/}
            {/*                    viewBox="0 0 24 24"*/}
            {/*                    stroke="currentColor"*/}
            {/*                    strokeWidth={2}*/}
            {/*                >*/}
            {/*                    <path*/}
            {/*                        strokeLinecap="round"*/}
            {/*                        strokeLinejoin="round"*/}
            {/*                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"*/}
            {/*                    />*/}
            {/*                </svg>*/}
            {/*                <span className="hidden sm:inline">{username}</span>*/}
            {/*                <svg*/}
            {/*                    xmlns="http://www.w3.org/2000/svg"*/}
            {/*                    className={`h-4 w-4 transition-transform ${isMenuOpen ? 'rotate-180' : ''}`}*/}
            {/*                    fill="none"*/}
            {/*                    viewBox="0 0 24 24"*/}
            {/*                    stroke="currentColor"*/}
            {/*                    strokeWidth={2}*/}
            {/*                >*/}
            {/*                    <path*/}
            {/*                        strokeLinecap="round"*/}
            {/*                        strokeLinejoin="round"*/}
            {/*                        d="M19 9l-7 7-7-7"*/}
            {/*                    />*/}
            {/*                </svg>*/}
            {/*            </button>*/}

            {/*            /!* Dropdown Menu *!/*/}
            {/*            {isMenuOpen && (*/}
            {/*                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-20">*/}
            {/*                    /!* User Info *!/*/}
            {/*                    <div className="px-4 py-2 border-b border-gray-100">*/}
            {/*                        <p className="text-sm text-gray-500">Logged in as</p>*/}
            {/*                        <p className="text-sm font-semibold text-gray-800">{username}</p>*/}
            {/*                    </div>*/}

            {/*                    /!* Logout Button *!/*/}
            {/*                    <button*/}
            {/*                        onClick={handleLogout}*/}
            {/*                        className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors flex items-center"*/}
            {/*                    >*/}
            {/*                        <svg*/}
            {/*                            xmlns="http://www.w3.org/2000/svg"*/}
            {/*                            className="h-4 w-4 mr-2"*/}
            {/*                            fill="none"*/}
            {/*                            viewBox="0 0 24 24"*/}
            {/*                            stroke="currentColor"*/}
            {/*                            strokeWidth={2}*/}
            {/*                        >*/}
            {/*                            <path*/}
            {/*                                strokeLinecap="round"*/}
            {/*                                strokeLinejoin="round"*/}
            {/*                                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"*/}
            {/*                            />*/}
            {/*                        </svg>*/}
            {/*                        Logout*/}
            {/*                    </button>*/}
            {/*                </div>*/}
            {/*            )}*/}
            {/*        </div>*/}

            {/*        /!* Click outside to close menu *!/*/}
            {/*        {isMenuOpen && (*/}
            {/*            <div*/}
            {/*                className="fixed inset-0 z-10"*/}
            {/*                onClick={() => setIsMenuOpen(false)}*/}
            {/*            ></div>*/}
            {/*        )}*/}
            {/*    </div>*/}

            {/*    /!* Main Header - Clean and Simple *!/*/}
            {/*    <div className="bg-gradient-to-r from-green-700 to-green-950 text-white text-2xl sm:text-3xl font-bold p-4 sm:p-6 rounded-b-2xl text-center">*/}
            {/*        BTC FIELD SERVICES*/}
            {/*    </div>*/}
            {/*    <p className="text-base sm:text-lg text-gray-600 mt-4 text-center px-2">*/}
            {/*        Access professional services and support from our field team*/}
            {/*    </p>*/}
            {/*</header>*/}

            {/* Services Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                {servicesToRender.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => handleNavigation(item.path)}
                        className="bg-white rounded-xl shadow-md p-6 cursor-pointer transition-all duration-300 transform hover:scale-105 flex flex-col items-center text-center h-full border border-gray-100 hover:border-blue-300"
                        style={{
                            animationDelay: `${index * 0.1}s`,
                            animation: 'fadeInUp 0.5s ease-out forwards',
                            opacity: 0,
                            transform: 'translateY(20px)'
                        }}
                    >
                        <div className="mb-4">{item.icon}</div>
                        <h2 className="text-xl font-semibold text-gray-800 mb-2">{item.title}</h2>
                        <p className="text-gray-600 mb-4 flex-grow">{item.description}</p>
                        <div className="mt-auto px-4 py-2 bg-blue-50 rounded-full text-sm font-medium text-green-700 border border-blue-200 hover:bg-blue-100 transition-colors duration-200">
                            Access Service
                        </div>
                    </div>
                ))}
            </div>

            <footer className="mt-12 text-center text-gray-500 text-sm">
                <p>BTC Portal </p>
            </footer>

            <style>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </div>
    );
}